/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.height-85-vh[_ngcontent-%COMP%]{height:85vh}.grow[_ngcontent-%COMP%]{-ms-flex-positive:1;flex-grow:1}.flex-column[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.top-padding[_ngcontent-%COMP%]{padding-top:15px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3Ivc2F2ZS1wcmV2aWV3LW1vZGFsL3NhdmUtcHJldmlldy1tb2RhbC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9yZWNvcmQtZWRpdG9yL3NhdmUtcHJldmlldy1tb2RhbC9zYXZlLXByZXZpZXctbW9kYWwuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/record-editor/save-preview-modal/save-preview-modal.component.scss.shim.ngstyle.ts